import { render, staticRenderFns } from "./footer_nav.vue?vue&type=template&id=9e34b900&scoped=true&"
import script from "./footer_nav.vue?vue&type=script&lang=js&"
export * from "./footer_nav.vue?vue&type=script&lang=js&"
import style0 from "./footer_nav.vue?vue&type=style&index=0&id=9e34b900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e34b900",
  null
  
)

export default component.exports